<template>
  <el-card class="logistics-card">
    <el-form :model="logisticsForm" label-width="100px">
      <el-form-item :label="$t('mobile.outSelect.channel')">
        <el-select
            v-model="formInline.channelId"
            filterable
            reserve-keyword
            :placeholder="$t('mobile.outSelect.prompt')"
            remote-show-suffix
            :loading="loading"
            style="width: 200px"
            @change="handleChange"
        >
          <el-option
              v-for="item in channelList"
              :key="item.myLogisticsChannelId"
              :label="item.myLogisticsChannelName"
              :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item  :label="$t('mobile.outSelect.tracking')">
        <el-input autofocus style="width:200px" v-model="formInline.sendNumber" :placeholder="$t('mobile.outSelect.number')" ></el-input>
      </el-form-item>
      <div class="flex flex-row-center">
        <el-button  type="primary"  @click="syncLogistics">{{$t('mobile.outSelect.shipment')}}</el-button>
      </div>

    </el-form>
  </el-card>
</template>

<script>
import {ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput,ElMessage} from "element-plus";
import {getChannel,outSend} from "@/utils/api"
export default {
  name: "outSelect",
  components:{
    ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput
  },
  data() {
    return {
      formInline: {
        sendSaleNumber:"",
        channelId:"",
        sendNumber:"",
      },
      channelList:[],
    };
  },
  beforeMount() {
    this.formInline.sendSaleNumber = this.$route.query.sendSaleNumber;
    this.loadData();
  },
  methods: {
    loadData(){
      getChannel({openFlag:1}).then(res=>{
        this.channelList = res.Data.filter((item)=>{
          return item.myLogisticsChannelName.includes('UPS（未对接马帮）')
              || item.myLogisticsChannelName.includes('CEVA（未对接马帮）')
              || item.myLogisticsChannelName.includes('Fedex')
              || item.myLogisticsChannelName.includes('ASTAS');
        });
        for(let i=0;i<this.channelList.length;i++){
          if(this.channelList[i].myLogisticsChannelName.includes("UPS")){
            this.channelList[i].myLogisticsChannelName =   "UPS"
          }
          if(this.channelList[i].myLogisticsChannelName.includes("CEVA")){
            this.channelList[i].myLogisticsChannelName = "CEVA"
          }
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    syncLogistics() {
      if (!this.formInline.sendSaleNumber){
        ElMessage.error(this.$t('mobile.outSelect.return'))
        return
      }
      if (!this.formInline.channelId){
        ElMessage.error(this.$t('mobile.outSelect.choose'))
        return
      }
      if (!this.formInline.sendNumber){
        ElMessage.error(this.$t('mobile.outSelect.number'))
        return
      }
      outSend(this.formInline).then(res=>{
        ElMessage.success(this.$t('saveSuccess') )
         // 等待1秒
         setTimeout(() => {
           this.$router.push('/outList');
         }, 1000);
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    }
  }
};
</script>

<style scoped>
.logistics-card {
  margin: 20px;
  padding: 20px;
  border-radius: 10px;
}
</style>
